import { render } from "./FormManterCalculoMedia.vue?vue&type=template&id=04824ad2"
import script from "./FormManterCalculoMedia.vue?vue&type=script&lang=js"
export * from "./FormManterCalculoMedia.vue?vue&type=script&lang=js"

import "./FormManterCalculoMedia.vue?vue&type=style&index=0&id=04824ad2&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__